import { styled } from '@mui/material/styles';
import { maxWidth } from '../../../mui/components/sharedStyles/layoutStyles';
import { renderTypographyStyles } from '../../../mui/base/utils';

export const alertStyles = ({ theme, alert }) =>
  alert &&
  `
    border-radius: ${theme.DS_border.radius.button};
    padding: ${theme.DS_spacing(['xs'])};
    padding-right: ${theme.DS_spacing(['md'])};
    text-align: left;
    ${theme.breakpoints.up('lg')} {
        padding: ${theme.DS_spacing(['sm'])} ${theme.DS_spacing(['xl'])};
         padding-right: ${theme.DS_spacing(['lg'])};
    }
  `;

export const overWriteBackColorStyle = ({ theme, overWriteBackColor }) =>
  overWriteBackColor &&
  `
    background-color: ${theme.DS_palette.primary.black};
  `;

export const dynamicBannerStyles = ({ theme, backgroundColor, textColor }) =>
  backgroundColor &&
  `
    background-color: ${backgroundColor || theme.DS_palette.primary.main};
    color: ${textColor || theme.DS_palette.primary.white};
  `;

export const bfStyles = ({ theme, $BFstyles, impress }) =>
  $BFstyles &&
  `
    
     min-height: 48px;

     > div {
      flex-direction: column;
      p { 
        margin-right: ${impress ? `32px` : 0};
       }
      }
     a {
       text-decoration: none !important;
       background-color: ${theme.DS_palette.tag.text};
       padding: 1px 10px 2px 10px;
       border-radius: 12px;
       margin: 6px 0 2px !important;
       line-height: 17px;
     
     

       &:hover {
         background-color: ${theme.DS_palette.cards.attention};
       }
     }
     
     ${theme.breakpoints.up('lg')} { 
        a {
          margin: 0 12px !important;
    
         } 
        > div {flex-direction: row;}
      }
  `;

export const impressBannerStyles = ({ theme, impress, $BFstyles, $gradientBackgroundOption }) =>
  impress &&
  `
   min-height: 48px;
   background: ${
     $gradientBackgroundOption
       ? $gradientBackgroundOption
       : $BFstyles
       ? `linear-gradient(270deg, #000000, #555555, #555555,  #000000, #444444)`
       : `linear-gradient(270deg, #83afff, #2263d9, #2263d9,  #83afff, #0059FA)`
   };

    background-size: 400% 400%;
    animation: gradientAnim 5s linear infinite;
        
    @keyframes gradientAnim {
        0%{background-position:0% 50%}
        100%{background-position: 100% 50%}
     
    }
    > div {
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        margin: 0;
        width: 100%;
        text-align: left;

        
        ${maxWidth};
         > a {
          margin-right:  ${theme.DS_spacing(['xl'])} !important;
          white-space: nowrap;
         }
      }
       ${theme.breakpoints.up('md')} {
         padding-left:  ${theme.DS_spacing(['md'])};
          padding-right:  ${theme.DS_spacing(['sm'])};

       }
    
       ${theme.breakpoints.up('lg')} {
          justify-content: space-between;
           padding-left: 54px;
       }
    
  
  `;

export const BannerWrapper = styled('div')`
  padding: 0;
`;

export const Banner = styled('section')(
  ({ theme, backgroundColor, textColor, alert, overWriteBackColor, impress, $BFstyles, $gradientBackgroundOption }) => `
  min-height: ${theme.DS_spacing(['xl'])};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['xs'])};
  position: relative;

  ${dynamicBannerStyles({ theme, backgroundColor, textColor })};
  ${alertStyles({ theme, backgroundColor, alert })};
  ${overWriteBackColorStyle({ theme, overWriteBackColor })};
  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    margin: ${alert ? 0 : ` 0 ${theme.DS_spacing(['sm'])}`};
      
    p {
      margin: 0;
      ${renderTypographyStyles(theme.typography.DS_copySmallRegular)}
    }


    a {
      text-decoration: underline;
      margin: 0 ${theme.DS_spacing(['xxs'])};
      color: ${theme.DS_palette.primary.white};
      text-transform: uppercase;
      &:hover {
       text-decoration: none;
       color: ${theme.DS_palette.primary.white};
      }
    }
    
  }
   ${bfStyles({ theme, $BFstyles, impress })}
  ${impressBannerStyles({ theme, impress, $BFstyles, $gradientBackgroundOption })};
 
`,
);

export const StyledCloseButton = styled('button')(
  ({ theme, alert, impress }) => `
      position: absolute;
      top: ${alert ? `${theme.DS_spacing(['xxxs'])}` : `calc(50% - 9px)`};
      right: ${
        alert
          ? `${theme.DS_spacing(['xxxs'])}`
          : impress
          ? `${theme.DS_spacing(['lg'])}`
          : `${theme.DS_spacing(['xxsx'])}`
      };

      svg {
        path {
          stroke: ${theme.DS_palette.primary.white};
        }
  
        font-size: ${theme.DS_spacing(['sm'])};
      }  
      
      ${theme.breakpoints.up('md')} {

           right: ${
             alert
               ? `${theme.DS_spacing(['xxxs'])}`
               : impress
               ? `${theme.DS_spacing(['lg'])}`
               : `${theme.DS_spacing(['xxs'])}`
           };
      }
      
      ${theme.breakpoints.up('lg')} {
   
          top: ${alert ? `${theme.DS_spacing(['xxxs'])}` : `calc(50% - 10px)`};
   
      }
   
    `,
);

export const StyledTextContainer = styled('div')(
  ({ theme, impress }) => `
       display: ${impress ? `flex` : `block`};
       align-items: center;
        
       svg {
        fill: transparent;
        margin-right: 8px;
        transform: translateY(1px);
         ${theme.breakpoints.up('lg')} {
         transform: translateY(-1px);
      }
         
        g {
           stroke: white;
         }
       }
   
    `,
);

export const StyledWrapper = styled('div')(
  () => `
      position: relative;
      width: 100%;
     
    `,
);
